import React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function FastestPayers({ fastestPayers = [] }) {
  const getPaymentSpeedColor = (days) => {
    if (days >= 0 && days <= 7) return "#28a745"; // Yeşil
    if (days >= 8 && days <= 30) return "#ffc107"; // Sarı
    if (days > 30) return "#dc3545"; // Kırmızı
    return "#6c757d"; // Varsayılan gri
  };

  const getPaymentSpeedLabel = (days) => {
    if (days >= 0 && days <= 7) return "0-7 gün";
    if (days >= 8 && days <= 30) return "8-30 gün";
    if (days > 30) return "30+ gün";
    return "Bilinmiyor";
  };

  return (
    <MDBox>
      <MDTypography variant="h6" color="dark" mb={2}>
        En Hızlı Ödeme Yapan Müşteriler
      </MDTypography>

      {/* Renk açıklaması */}
      <div style={{ marginBottom: "12px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <div
            style={{
              width: "12px",
              height: "12px",
              backgroundColor: "#28a745",
              borderRadius: "50%",
            }}
          ></div>
          <span style={{ fontSize: "12px", color: "#666" }}>0-7 gün</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <div
            style={{
              width: "12px",
              height: "12px",
              backgroundColor: "#ffc107",
              borderRadius: "50%",
            }}
          ></div>
          <span style={{ fontSize: "12px", color: "#666" }}>8-30 gün</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <div
            style={{
              width: "12px",
              height: "12px",
              backgroundColor: "#dc3545",
              borderRadius: "50%",
            }}
          ></div>
          <span style={{ fontSize: "12px", color: "#666" }}>30+ gün</span>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          height: "400px",
          overflow: "auto",
          border: "1px solid #e9ecef",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f8f9fa" }}>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "left",
                  borderBottom: "1px solid #e9ecef",
                  color: "#344767",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Müşteri Adı
              </th>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "center",
                  borderBottom: "1px solid #e9ecef",
                  color: "#344767",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Ortalama Ödeme Süresi
              </th>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "center",
                  borderBottom: "1px solid #e9ecef",
                  color: "#344767",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Hız Kategorisi
              </th>
            </tr>
          </thead>
          <tbody>
            {fastestPayers.length > 0 ? (
              fastestPayers.slice(0, 10).map((customer, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: "1px solid #e9ecef",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.target.parentElement.style.backgroundColor = "#f8f9fa";
                  }}
                  onMouseLeave={(e) => {
                    e.target.parentElement.style.backgroundColor = "transparent";
                  }}
                >
                  <td
                    style={{
                      padding: "12px 16px",
                      color: "#344767",
                      fontSize: "14px",
                    }}
                  >
                    {customer.customerName || "Bilinmeyen Müşteri"}
                  </td>
                  <td
                    style={{
                      padding: "12px 16px",
                      textAlign: "center",
                      color: "#344767",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    {customer.averagePaymentDays || 0} gün
                  </td>
                  <td
                    style={{
                      padding: "12px 16px",
                      textAlign: "center",
                      color: "#344767",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: getPaymentSpeedColor(customer.averagePaymentDays || 0),
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      {getPaymentSpeedLabel(customer.averagePaymentDays || 0)}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={3}
                  style={{
                    padding: "24px 16px",
                    textAlign: "center",
                    color: "#344767",
                    fontSize: "14px",
                  }}
                >
                  Henüz ödeme verisi bulunmuyor
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </MDBox>
  );
}

FastestPayers.propTypes = {
  fastestPayers: PropTypes.arrayOf(
    PropTypes.shape({
      customerName: PropTypes.string,
      averagePaymentDays: PropTypes.number,
    })
  ),
};

export default FastestPayers;
